import TopUI from "./top/ui";
import Intro from './top/intro';
import Pass from './top/pass';
import Howto from './top/howto';

const ui = new TopUI();
const intro = new Intro();
const howto = new Howto();
const pass = new Pass(()=>{
    intro.start();
});
